import { render } from "./ToggleIcon.vue?vue&type=template&id=4b5c4430"
import script from "./ToggleIcon.vue?vue&type=script&lang=js"
export * from "./ToggleIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__